<template>
  <div class="mt-2">
    <div class="d-flex">
      <ul class="w-75"><li>La sección Tarifas, te permite consultar, actualizar y cargar nuevas tarifas.</li></ul>
      <div class="w-25 text-right"><b-button :disabled="!company.id" variant="warning" @click="openModal('ModalNewImportAuditorConnect')"> <feather-icon icon="DollarSignIcon" /> Nueva Tarifa </b-button></div>
    </div>
		<form-render
			ref="formAuditorConnect"
			:key="keyAuditorConnect"
			:fields="fields"
			:form.sync="form"
			:containerButtonsClass="'col-sm-12 col-md-6 col-lg-6 mt-2 mb-4 pl-0 pr-0'"
		>
			<template #buttons>
        <div :class="[m_isAdmin() && 'd-flex justify-content-end', 'd-flex']">
          <b-button variant="warning" :disabled="loading.coverages" @click="checkForm()">
            <b-spinner v-if="loading.coverages" small></b-spinner>
            <feather-icon icon="SearchIcon" v-if="!loading.coverages"/>
          </b-button>
          <b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="ml-1 mr-1" @click="cleanFilter" :disabled="loading.coverages">
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </div>
			</template>
		</form-render>
    <aditional-filters-export-history v-if="showAditionalFilters" @changeRate="changeRate" @getCoverages="getCoverages" @cleanFilter="cleanFilter" :dataTableAuditorConnect="dataTableAuditorConnect"></aditional-filters-export-history>
    <auditor-connect-table v-if="showTable && !loading.dataTable" :dataTableAuditorConnect="dataTableAuditorConnect"/>
    <pagination v-if="showTable && !loading.dataTable" :pagination="pagination" :showSize="true"/>
    <div class="table-render-skeleton mt-1" v-show="showTable && loading.dataTable">
      <b-skeleton-table v-show="loading.dataTable" :rows="10" :columns="8" />
    </div>
    <modal-new-import-auditor-connect v-if="ModalNewImportAuditorConnect" :data="dataModalNewImport" @closeModal="closeModal"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import AuditorConnectTable from './components/AuditorConnectTable.vue'
import ModalNewImportAuditorConnect from './components/ModalNewImportAuditorConnect.vue'
import AditionalFiltersExportHistory from './components/AditionalFiltersExportHistory.vue'

export default {
  components: { AuditorConnectTable, ModalNewImportAuditorConnect, AditionalFiltersExportHistory },
  name: 'TariffsAuditorConnect',
  props: {
    company: {
      type: Object,
      default: () => ({})
    },
    country: {
      type: Object,
      default: () => ({})
    },
    countries: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      baseService: new BaseServices(this),
      keyAuditorConnect: 0,
      form: {place_name_from: null, place_name_to: null},
      fields: [],
      buttonSend: { icon: 'SearchIcon', title: 'Buscar', color: 'warning', disabled: false },
      showTable: false,
      ModalNewImportAuditorConnect: false,
      dataModalNewImport: {},
      loading: {
        coverages: false,
        dataTable: false
      },
      selectedRate: {},
      pagination: {
        page: 1,
        total: 0,
        limit: 20
      },
      showAditionalFilters: false
    }
  },
  mounted() {
    this.setInitialData()
  },
  computed: {
    ...mapGetters({
      companies: 'getCompaniesDeliveryConnect',
      carriers: 'getCarriersAuditorConnect',
      services: 'getServicesByCountryCarrier',
      generalLoading: 'getLoading'
    })
  },
  watch: {
    company() {
      this.setSkeletonField('carrier', true)
      this.$store.dispatch('fetchService', { name: 'getCarriersAuditorConnect', queryParams: { parent_company_id: this.m_isAdmin() ? this.company.parent_id : this.company.id } })
    },
    carriers() {
      this.setOptions('carriers', 'carrier')
      this.setSkeletonField('carrier', false)
    },
    services() {
      this.setOptions('services', 'service')
      this.setSkeletonField('service', false)
    },
    'pagination.page'(value) {
      this.pagination.page = value
      this.getCoverages()
    },
    'pagination.limit'(value) {
      this.pagination.limit = value
      this.getCoverages()
    },
    showTable(value) {
      if (!value) {
        this.showAditionalFilters = false
      }
    },
    generalLoading: {
      handler() {
        this.loadingAllCountries = !!this.generalLoading.getCompaniesConnect
      },
      deep: true
    }
  },
  methods: {
    setInitialData () {
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'carrier', label: 'Courier', containerClass: 'col-sm-12 col-md-3 col-lg-3', change: this.changeCarriers, sort: true, validation: 'required'},
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'service', label: 'Servicio', containerClass: 'col-sm-12 col-md-3 col-lg-3', change: this.changeService, dependency: 'carrier', sort: true, validation: 'required'}
      ]
    },
    setOptions(name, fieldName) {
      const fieldIndex = this.m_getElementIndex(this.fields, 'name', fieldName)
      if (fieldIndex !== -1) {
        this.fields[fieldIndex].options = this[name]?.rows || []
      }
    },
    setSkeletonField (name, bool) {
      const index = this.fields.findIndex(el => el.name === name)
      this.fields[index].useSlot = bool
      this.fields[index].useSkeleton = bool
      this.fields[index].useLabel = bool
    },
    getParams() {
      const params = {service_id: this.form.service?.id}
      return params
    },
    getQueryParams() {
      const queryParams = {}
      if (this.company?.id) queryParams.organization_id = this.company.id
      return queryParams
    },
    getRates () {
      this.loading.coverages = true
      this.baseService.callService('getAuditorRateHistory', this.getQueryParams(), this.getParams())
        .then((response) => {
          this.selectedRate = response.data?.find(el => el.type === 'current') || {}
          this.dataTableAuditorConnect = {
            rates: response.data || [],
            form: this.form,
            loading: this.loading
          }
          this.getCoverages()
        })
        .catch(err => {
          this.$newError('Ha ocurrido un problema', err.message, 'large')
          this.showTable = false
        })
    },
    getCoverages() {
      this.dataTableAuditorConnect.selectedRate = this.selectedRate
      this.showTable = true
      this.loading.coverages = true
      this.loading.dataTable = true
      const params = {rate_id: this.selectedRate?.id}
      const queryParams = {
        page: this.pagination.page,
        page_size: this.pagination.limit
      }
      if (this.company?.id) queryParams.company_id = this.company.id
      if (this.form?.place_name_from) queryParams.place_name_from = this.form.place_name_from
      if (this.form?.place_name_to) queryParams.place_name_to = this.form.place_name_to
      if (this.selectedRate?.id) {
        this.baseService.callService('getAuditorCoverages', queryParams, params)
          .then((response) => {
            this.setRows(response.data)
            this.pagination.total = response.meta?.total_rows || 0
            this.pagination.page = response.meta?.current_page || 1
            this.showAditionalFilters = true
          })
          .catch(err => {
            this.$newError('Ha ocurrido un problema', err.message, 'large')
            this.showTable = false
          })
          .finally(() => {
            this.loading.coverages = false
            this.loading.dataTable = false
          })
      } else {
        this.dataTableAuditorConnect.rows = []
        this.loading.coverages = false
        this.loading.dataTable = false
      }
    },
    setRows(response) {
      const allKeys = [...new Set(response.flatMap(entry => Object.keys(entry.weight_intervals).map(Number)))].sort((a, b) => a - b)
      // Seleccionar las 6 más bajas
      const lowestKeys = allKeys.slice(0, 6).map(String)
      const output = response.map(entry => {
        const result = {} // Copiar toda la información original
        result.lowest_intervals = {}
        lowestKeys.forEach(key => {
          result.lowest_intervals[key] = entry.weight_intervals[key] || null
          result[`${key}kg`] = entry?.weight_intervals[key]?.fp || null
          result.place_name_from = entry?.place_name_from || null
          result.place_name_to = entry?.place_name_to || null
        })
        return result
      })

      this.dataTableAuditorConnect.rows = output
    },
    changeCarriers(name, value) {
      if (!!value) {
        const params = {
          country_id: this.country.id,
          carrier_id: value.id
        }
        this.setSkeletonField('service', true)
        this.$store.dispatch('fetchService', { name: 'getServicesByCountryCarrier', params })
      } else {
        delete this.form.carrier
      }
      this.changeService('service', null)
      this.showTable = false
    },
    changeService(name, value) {
      if (!value) {
        delete this.form.service
      }
      this.showTable = false
      this.selectedRate = {}
    },
    changeRate(rate) {
      this.selectedRate = rate
      this.cleanFilter({ aditionalFilter: true })
    },
    async checkForm() {
      const isCheck = await this.$refs.formAuditorConnect.onlyCheckForm()
      if (isCheck) this.getRates()
    },
    cleanFilter({aditionalFilter = false}) {
      if (aditionalFilter) {
        this.form.place_name_from = null
        this.form.place_name_to = null
        this.getCoverages()
      } else {
        this.form = {place_name_from: null, place_name_to: null}
        this.showTable = false
      }
    },
    openModal(modal) {
      this[modal] = true
      console.log('this.countries', this.countries)
      this.dataModalNewImport.countries = this.countries
      this.$nextTick(() => {
        this.$bvModal.show(modal)
      })
    },
    closeModal(modal) {
      this.$bvModal.hide(modal)
      this[modal] = false
    }
  }
}
</script>